<button class="mobile-menu-toggler" (click)="toggleMenu($event)">
    <span class="sr-only">Toggle mobile menu</span>
    <i class="icon-bars"></i>
</button>


